import Menu from "./Menu";
import TabContent from "./TabContent";
import React from "react";

const Content = () => {
    return (
        <div className="cartick-content cartick-card">
            <Menu />
            <TabContent />
        </div>
    )
}

export default Content;